<template>
  <static-content-wrapper :designer="designer" :field="field" :design-state="designState"
                          :parent-widget="parentWidget" :parent-list="parentList" :index-of-parent-list="indexOfParentList"
                          :sub-form-row-index="subFormRowIndex" :sub-form-col-index="subFormColIndex" :sub-form-row-id="subFormRowId">
    
    <div :class="[field.options.otherClass]">
        <el-tree  
              ref="fieldEditor" 
              :data="data"
              :empty-text="field.options.emptyText"
              :node-key="field.options.nodeKey" 
              :render-after-expand="field.options.renderAfterExpand" 
              :highlight-current="field.options.highlightCurrent" 
              :default-expand-all="field.options.defaultExpandAll" 
              :expand-on-click-node="field.options.expandOnClickNode" 
              :auto-expand-parent="field.options.autoExpandParent" 
              :default-expanded-keys="field.options.defaultExpandedKeys" 
              :show-checkbox="field.options.showCheckbox" 
              :check-strictly="field.options.checkStrictly" 
              :default-checked-keys="field.options.defaultCheckedKeys" 
              :current-node-key="field.options.currentNodeKey" 
              :accordion="field.options.accordion" 
              :indent="field.options.indent"
              :icon-class="field.options.iconClass"
              :lazy="field.options.lazy"
              :draggable="field.options.draggable"
              :props="defaultProps" 
              :renderContent="renderContent"
              :load="load"
              @node-click="handleNodeClick"
              @check-change="handleCheckChange"
               >
    </el-tree>
  </div>
 </static-content-wrapper>
</template>

<script>
  import StaticContentWrapper from '@/components/form-designer/form-widget/field-widget/static-content-wrapper'
  import emitter from '@/utils/emitter'
  import i18n from "@/utils/i18n"
  import fieldMixin from "@/components/form-designer/form-widget/field-widget/fieldMixin"
  import request from "@/utils/request";
  export default {
    name: "treeWidget",
    componentName: 'FieldWidget',  //必须固定为FieldWidget，用于接收父级组件的broadcast事件
    mixins: [emitter, fieldMixin, i18n],
    props: {
      field: Object,
      parentWidget: Object,
      parentList: Array,
      indexOfParentList: Number,
      designer: Object,

      designState: {
        type: Boolean,
        default: false
      },

      subFormRowIndex: { /* 子表单组件行索引，从0开始计数 */
        type: Number,
        default: -1
      },
      subFormColIndex: { /* 子表单组件列索引，从0开始计数 */
        type: Number,
        default: -1
      },
      subFormRowId: { /* 子表单组件行Id，唯一id且不可变 */
        type: String,
        default: ''
      },

    },
    data() {
      return {
        defaultProps: {
          children: 'children',
          label: 'label'
        },
        data: [{
          id: 1,
          label: '一级 1',
          showAppend:true,
          children: [{
            id: 4,
            label: '二级 1-1',
            children: [{
              id: 9,
              label: '三级 1-1-1'
            }, {
              id: 10,
              label: '三级 1-1-2'
            }]
          }]
        }, {
          id: 2,
          label: '一级 2',
          showAppend:true,
          children: [{
            id: 5,
            label: '二级 2-1'
          }, {
            id: 6,
            label: '二级 2-2'
          }]
        }, {
          id: 3,
          showAppend:true,
          label: '一级 3',
          children: [{
            id: 7,
            label: '二级 3-1'
          }, {
            id: 8,
            label: '二级 3-2'
          }]
        }],
      };
    },
    components: {
      StaticContentWrapper,
    },
    created() {
      this.registerToRefList()
      this.initEventHandler()
      if(this.field.options.url!=''){
        this.loadDate()
      }
    },
    beforeDestroy() {
      this.unregisterFromRefList()
    },
    methods: {
      loadDate(){
        request({
          url: this.field.options.url,
          method: "get",
          params: {},
        }).then((response) => {
          this.total = response.data.total ? +response.data.total : 0;
          this.listData = response.data.data;
          if (this.total === 0) {
            this.haveData = false;
          } else {
            this.haveData = true;
          }
        });
      },
      append(_data) {
        // console.log(_data)
        let tmpFunc =  new Function('data',this.field.options.appendFunc)
        return tmpFunc.call(this,_data);
        // const newChild = { id: id++, label: 'testtest', children: [] };
        // if (!data.children) {
        //   this.$set(data, 'children', []);
        // }
        // data.children.push(newChild);
      },

      remove(node, data) {
        const parent = node.parent;
        const children = parent.data.children || parent.data;
        const index = children.findIndex(d => d.id === data.id);
        children.splice(index, 1);
      },
      renderContent(h, { node, data, store }) {
        if(this.field.options.appendNode){
          if(data.showAppend){
            return (
          <span class="custom-tree-node">
            <span>{node.label}</span>
            <span class='add-icon'>
              <i class='el-icon-circle-plus-outline' on-click={ () =>  this.append(data) }></i>
            </span>
          </span>);
          }else{
            return (
          <span class="custom-tree-node">
            <span>{node.label}</span>
          </span>);
          }
          
        }else{
          return (
          <span class="custom-tree-node">
            <span>{node.label}</span>
          </span>);
        }
        
      },
      getCheckedNodes() {
        return this.$refs.fieldEditor.getCheckedNodes();
      },
      getCheckedKeys() {
        return this.$refs.fieldEditor.getCheckedKeys();
      },
      setCheckedNodes(nodes) {
        this.$refs.fieldEditor.setCheckedNodes(nodes);
      },
      setCheckedKeys() {
        this.$refs.fieldEditor.setCheckedKeys([3]);
      },
      resetChecked() {
        this.$refs.fieldEditor.setCheckedKeys([]);
      },
      load(node, resolve){
        let tmpFunc =  new Function('node','resolve',this.field.options.load)
        return tmpFunc.call(this,node,resolve);
      },
      handleCheckChange(data,checked,indeterminate){
        let tmpFunc =  new Function(this.field.options.handleCheckChange)
        return tmpFunc.call(this,data,checked,indeterminate);
      },
      handleNodeClick(data,node,tree){
        let tmpFunc =  new Function('data','node','tree',this.field.options.handleNodeClick)
        return tmpFunc.call(this,data,node,tree);
      }
    }
  }
</script>

<style lang="scss" scoped>
.main-tree-style{
  padding: 30px;
  ::v-deep .add-icon{
  margin-left: 15px;
  color: $--color-primary;
  }
  ::v-deep .el-tree-node__content{
    height: 40px;
  }
  ::v-deep .el-tree-node__expand-icon.expanded{
    transform: none;
  }
  ::v-deep .el-tree-node__expand-icon.expanded::before{
    content: "\e6d8";
  }
  ::v-deep   .el-tree--highlight-current .el-tree-node.is-current>.el-tree-node__content{
    background-color: $--color-primary;
    color:#fff;
  }
}

</style>
